import { render, staticRenderFns } from "./ReportObservations.vue?vue&type=template&id=0dea2457&scoped=true"
import script from "./ReportObservations.vue?vue&type=script&lang=js"
export * from "./ReportObservations.vue?vue&type=script&lang=js"
import style0 from "./ReportObservations.vue?vue&type=style&index=0&id=0dea2457&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_webpack@4_6rzqd64q6y3fbidgrbnvwpeysm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dea2457",
  null
  
)

export default component.exports